import React, { Suspense, lazy } from 'react';
import { MyContext } from '../InitialSetup/MyProvider';
import { Utilities } from '../Utilities/Utilities';
import { MatchInfo, MomentDateComponent } from "../Component/CustomComponent";
import { getUserProfile, getUserBalance, getAppNotificationCount, getDailyCoins } from "../WSHelper/WSCallings";
import Images from './images';
import WSManager from "../WSHelper/WSManager";
import * as WSC from "../WSHelper/WSConstants";
import * as Constants from "../helper/Constants";
import * as AppLabels from "../helper/AppLabels";
import { Row, Col } from 'react-bootstrap'
const RefferCoachMark = lazy(()=>import('../Modals/RefferCoachMark'));
const Banner = lazy(()=>import('../Modals/Banner'));
const MyAlert = lazy(()=>import('../Modals/MyAlert'));

var lastBlanceCallDate = {};
var globalThis = null;

export default class CustomHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mTotalBalance: "",
            showResetAlert: false,
            message: AppLabels.RESET_ACTION,
            notificationData: Constants.NOTIFICATION_DATA,
            allowCollection: Utilities.getMasterData().a_collection,
            showTooltip: true,
            lineupArr: [],
            showDCBM: false,
            showCoinCM: false,
            showRCM: false,
            refRCMData: '',
            dailyData: '',
            isBannerShow: false,
            userCoinBalnc: (WSManager.getBalance().point_balance || 0),
            selectedGameType: WSManager.getPickedGameType(),
            showRSuccess: false,
            redeemData: '',
            showRedeemCM: false,
            DailyCheckinBonus: null,
            CoinCoachMarks: null,
            RedeemSuccess: null,
            ReedemCoachMarks: null,
            SHCoachMarks: null,
            showSHSCM: false,
            NEWP: false,
            NPMSG: '',
            sourceUrlShow: false,
            sourceUrlData: '',
            isFilterselected: false,
            filterBy: '',
            LobyyData: {
                home_flag: '',
                away_flag: '',
                home: '--',
                away: '--',
                collection_name: '--',
                game_starts_in: 0,
                today: 0,
                season_scheduled_date: 0,
            }
        }
    }

    componentDidMount() {  

        if (Utilities.getMasterData().a_coin == '1') {
            // import('../Component/CoinsModule').then(CM => {
            //     if (CM.EarnCoins) {
                    this.setState({
                        DailyCheckinBonus: lazy(()=>import('../Component/CoinsModule/DailyCheckinBonus')),
                        CoinCoachMarks: lazy(()=>import('../Component/CoinsModule/CoinCoachMarks')),
                        RedeemSuccess: lazy(()=>import('../Component/CoinsModule/RedeemSuccess')),
                        ReedemCoachMarks: lazy(()=>import('../Component/CoinsModule/ReedemCoachMarks'))
                    });
            //     }
            // });
        }

        if (Constants.IS_SPORTS_HUB) {
            // import('../Component/SportsHub').then(CM => {
            //     if (CM.SHCoachMarks) {
                    this.setState({
                        SHCoachMarks: lazy(()=>import('../Component/SportsHub/SHCoachMarks'))
                    });
                // }
            // });
        }

        if (WSManager.loggedIn()) {
            var page_pathname = window.location.pathname;
            if(page_pathname === "/add-funds") {
            
                setTimeout(() => {
                    this.callUserBalanceApi();
                }, 500);
            }
            if (!WSManager.getProfile().user_setting) {
                this.callGetMyProfileApi();
            } else {
                this.showWhatsNew(WSManager.getProfile());
            }
            setTimeout(() => {
                this.getAPiNotificationCount();
            }, 2500);
            let lsBannerData = WSManager.getBannerData();
            let mdBannerData = Utilities.getMasterData().banner;
            if (mdBannerData && (!lsBannerData  || lsBannerData.app_banner_id !=  mdBannerData.app_banner_id)) {
                this.isDisplayBanner();
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.LobyyData && nextProps.LobyyData && this.state.LobyyData.collection_name != nextProps.LobyyData.collection_name) {
            this.setState({ LobyyData: nextProps.LobyyData })
        }
    }

    componentWillUnmount() {
        this.setState = () => {
            return;
        };
    }

    getAPiNotificationCount() {

        let minuts = Constants.NOTIFICATION_DATA.date ? Utilities.minuteDiffValue(Constants.NOTIFICATION_DATA) : 0;
        if (this.props.HeaderOption.notification && (minuts === 0 || minuts > 0.7)) {
            getAppNotificationCount().then((responseJson) => {
                if (responseJson.response_code == WSC.successCode) {
                    if (typeof responseJson.data != "undefined") {
                        let obj = { date: Date.now(), count: responseJson.data }
                        Constants.setValue.setNotificationCount(obj);
                        this.setState({ notificationData: obj })
                    }
                }
            })
        }
    }

    static changeFilter = (value,filterBy) => {
        globalThis.setState({ 
            isFilterselected: value,
            filterBy : filterBy
        })
    }

    callGetMyProfileApi() {
        let param = {
        }

        getUserProfile(param).then((responseJson) => {
            if (responseJson && responseJson.response_code == WSC.successCode) {
                WSManager.setProfile(responseJson.data);
                this.setState({ profile: responseJson.data });
                this.showWhatsNew(responseJson.data);
            }
        })
    }

    callUserBalanceApi() {
        if (!lastBlanceCallDate.date || Utilities.minuteDiffValue(lastBlanceCallDate) > 1) {
            lastBlanceCallDate['date'] = Date.now();
            getUserBalance().then((responseJson) => {
                if (responseJson && responseJson.response_code == WSC.successCode) {
                    WSManager.setAllowedBonusPercantage(responseJson.data.allowed_bonus_percantage)
                    WSManager.setBalance(responseJson.data.user_balance);
                    let tempBalance = Utilities.getTotalUserBalance((responseJson.data.user_balance.bonus_amount || 0), (responseJson.data.user_balance.real_amount || 0), (responseJson.data.user_balance.winning_amount || 0))
                    this.setState({ mTotalBalance: Utilities.kFormatter(tempBalance), userCoinBalnc: responseJson.data.user_balance.point_balance });
                }
            })
        } else {
            let lsbalance = WSManager.getBalance() || {};
            let tempBalance = Utilities.getTotalUserBalance((lsbalance.bonus_amount || 0), (lsbalance.real_amount || 0), (lsbalance.winning_amount || 0))
            this.setState({ mTotalBalance: Utilities.kFormatter(tempBalance), userCoinBalnc: (lsbalance.point_balance || 0) });
        }
    }

    getDailyStreakCoins = () => {
        let param = {}
        getDailyCoins(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({ dailyData: responseJson.data, showDCBM: responseJson.data.allow_claim === 1 })
                WSManager.setDailyData(responseJson.data)
            }
        })
    }

    showWhatsNew = (data) => {
        let isSporthub = Constants.IS_SPORTS_HUB ? Constants.SELECTED_GAMET : true;
        const {
            HeaderOption,
        } = this.props;
        if (!HeaderOption.isOnb && isSporthub && Utilities.getMasterData().a_coin !== "0" && !WSManager.getShareContestJoin()) {
            // if (data.user_setting && data.user_setting.earn_coin == "0") {
            //     this.props.history.push({ pathname: '/what-is-new', state: { isFirst: true } })
            // } else {
                let todayString = new Date().toDateString();
                if (WSManager.getDailyData().day_string !== todayString) {
                    this.getDailyStreakCoins();
                } else {
                    this.setState({ dailyData: WSManager.getDailyData(), showDCBM: WSManager.getDailyData().allow_claim === 1 })
                }
            // }
        }
    }

    static showDailyStreak = () => {
        globalThis.setState({ showDCBM: true })
    }

    hideDailyCheckIn = () => {
        this.setState({ showDCBM: false })
    }

    static showCoinCM = () => {
        globalThis.setState({ showCoinCM: Constants.IS_SPORTS_HUB ? false : true })
    }

    hideCoinCM = () => {
        this.setState({ showCoinCM: false })
    }

    static showSHSCM = () => {
        globalThis.setState({ showSHSCM: true })
    }

    hideSHSCM = () => {
        this.setState({ showSHSCM: false })

    }
    static showRCM = (data) => {
        if (WSManager.getProfile().user_setting && WSManager.getProfile().user_setting.refer_a_friend == "0") {
            globalThis.setState({ showRCM: true, refRCMData: data })
        }

    }

    hideRCM = () => {
        this.setState({ showRCM: false })
    }

    static showUrlModal=(data)=>{
        globalThis.setState({
            sourceUrlShow: true,
            sourceUrlData: data
        })
    }

    hideUrmModal=()=>{
        this.setState({
            sourceUrlShow: false
        })
    }
    
    static showRSuccess = (value) => {
        globalThis.setState({ showRSuccess: true, redeemData: value })
    }

    hideRSuccess = () => {
        this.setState({ showRSuccess: false })
    }

    static showRedeemCM = () => {
        if (!globalThis.state.showDCBM && !globalThis.state.showCoinCM && !globalThis.state.showRSuccess && !globalThis.state.isBannerShow) {
            globalThis.setState({ showRedeemCM: true })
        }
    }

    hideRedeemCM = () => {
        this.setState({ showRedeemCM: false });
    }

    static updateCoinBalance = (bal) => {
        globalThis.setState({ userCoinBalnc: bal })
    }

    isDisplayBanner() {
        let masterData = Utilities.getMasterData();
        if (masterData.banner) {
            this.setState({ isBannerShow: true })
        } else {
            this.setState({ isBannerShow: false })
        }
    }

    onBannerHide() {
        let masterData = Utilities.getMasterData();
        this.setState({ isBannerShow: false });
        WSManager.setBannerData(masterData.banner)
    }

    hidePitchToolTip = () => {
        setTimeout(() => {
            this.setState({
                showTooltip: false
            })
        }, 3000)
        return true;
    }

    AlertgoBack = () => {
        if (this.state.lineupArr && this.state.lineupArr.length > 0) {
            this.setState({ showResetAlert: true })
        }
        else {
            this.goBackScreen()
        }
    }

    GetHeaderProps = (type, data, master, lobby, FixturedContest, isFrom, rootDataItem, teamData, teamName) => {
        if (teamName) {
            this.setState({ teamName: teamName })
        }
        this.setState({ lineupArr: data, masterData: master, LobyyData: lobby, FixturedContest: FixturedContest, isFrom: isFrom, rootDataItem: rootDataItem, team: teamData })
    }

    showFilter = () => {
        this.props.showLobbyFitlers();
    }

    resetConfirm() {
        this.setState({ showResetAlert: true })
    }

    resetConfirmHide() {
        this.setState({ showResetAlert: false })
    }

    goToScreen = (pathname) => {
        this.props.history.push(pathname);
    }

    goBackScreen = () => {
        if(this.props && this.props.location.state && this.props.location.state.isFrom == 'lineup-flow'){
            this.props.history.replace('/lobby' + "#" + Utilities.getSelectedSportsForUrl() + Utilities.getGameTypeHash())
        }
        else if( WSManager.getIsFromPayment()== 'true'){
            WSManager.setIsFromPayment(false)
            this.props.history.replace('/lobby' + "#" + Utilities.getSelectedSportsForUrl() + Utilities.getGameTypeHash())
        }
        else{
            this.props.history.goBack();
        }
    }

    GobackToLobby = () => {
        if (this.props.HeaderOption.resetIndex && this.props.HeaderOption.resetIndex > 0) {
            this.props.history.go(-this.props.HeaderOption.resetIndex);
        } else {
            let urlParams = Utilities.setUrlParams(this.state.LobyyData);
            let sportsId = Utilities.getSelectedSportsForUrl();
            let collection_master_id = this.state.LobyyData.collection_master_id;
            this.props.history.push({ pathname: "/" + sportsId + '/my-teams/' + collection_master_id + "/" + urlParams, state: { LobyyData: this.state.LobyyData } })
        }

        this.setState({ showResetAlert: false })
        WSManager.clearLineup();
    }


    renderLeftSection = (HeaderOpt) => {
        if (HeaderOpt.back) {
            var backAction = this.goBackScreen;
            if (HeaderOpt.showAlertRoster) {
                backAction = this.AlertgoBack
            } else if (HeaderOpt.goBackLobby) {
                backAction = () => {
                    this.goToScreen("/lobby#" + Utilities.getSelectedSportsForUrl())
                }
            }
            return <a href className="header-action" onClick={backAction}><i className="icon-left-arrow"></i></a>
        }
        else if (WSManager.loggedIn() && HeaderOpt.title !== AppLabels.WHATSNEW) {
            return (
                <div className='center-container text-left' onClick={() => this.goToScreen('/my-wallet')}>
                    <a href className="header-action">
                        <i className="icon-wallet-ic"></i>
                    </a>
                </div>
            )
        }

           

    }

    renderMiddleSection = (HeaderOpt) => {
        if ((HeaderOpt.fixture || HeaderOpt.leaderboard) && this.state.LobyyData) {
            return <MatchInfo item={this.state.LobyyData} status={HeaderOpt.status}/>
        }
        else if (HeaderOpt.fixtureDate && this.state.LobyyData) {
            return <MatchInfo item={this.state.LobyyData} status={HeaderOpt.status} onlyTimeShow={HeaderOpt.fixtureDate} />
        }
        else if (HeaderOpt.title && HeaderOpt.FPPLeaderboard){
            return <div className={'app-header-text selected-cat-text' + (this.state.filterBy != '' ? ' cat-name-exist' : '')}>
                {
                   this.state.filterBy != '' &&
                    <span> 
                        {this.state.filterBy}
                    </span>
                }
                 {HeaderOpt.title}
            </div>
        }
        else if (HeaderOpt.title && !HeaderOpt.FPPLeaderboard) {
            return <div className={'app-header-text' + (this.state.filterBy != '' ? ' cat-name-exist' : '')}>
                {HeaderOpt.title} 
                {
                    this.state.filterBy != '' &&
                    <div className="selected-cat-nm">{this.state.filterBy}</div>
                }
            </div>
        } else if (!HeaderOpt.back || HeaderOpt.MLogo) {
            return <div className='center-container'>
                <img onClick={() => this.goToScreen("/lobby#" + Utilities.getSelectedSportsForUrl())} className='header-brand-logo' alt="" src={HeaderOpt.isPrimary || HeaderOpt.DFSPrimary ? Images.WHITE_BRAND_LOGO : Images.BRAND_LOGO}></img>
            </div>
        }else if (HeaderOpt.screentitle && HeaderOpt.leagueDate) {
            return (
                <React.Fragment>
                    <div className="match-info-section">

                        <div className="section-middle">
                            {
                                <span className={"team-home" + (HeaderOpt.minileague ? ' no-transform' : '')}>
                                    {HeaderOpt.screentitle}
                                </span>
                            }
                            {
                                <div className="match-timing">
                                    {<span> <MomentDateComponent data={{ date: HeaderOpt.leagueDate.scheduled_date, format: "D MMM" }} />
                             -  <MomentDateComponent data={{ date: HeaderOpt.leagueDate.end_date, format: "D MMM" }} />
                                    </span>}
                                </div>
                            }
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        else if (HeaderOpt.screentitle && HeaderOpt.rank) {
            return (
                <React.Fragment>
                    <div className="match-info-section">

                        <div className="section-middle">
                            {
                                <span className="team-home">
                                    {HeaderOpt.screentitle}
                                </span>
                            }
                            {
                                <div className="match-timing">
                                    {<span> {HeaderOpt.rank}</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    
                </React.Fragment>
            )
        }
        else if (HeaderOpt.referalLeaderboradTitle && HeaderOpt.referalLeaderboradSubTitle) {
            return (
                <React.Fragment>
                    <div className="match-info-section">

                        <div className="section-middle">
                            {
                                <span className="team-home-rf-leaderboard">
                                    {HeaderOpt.referalLeaderboradTitle}
                                </span>
                            }
                            {
                                <div className="match-timing-rf-leaderboard">
                                    {<span> {HeaderOpt.referalLeaderboradSubTitle}</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    
                </React.Fragment>
            )
        }

    }

    onHRightBlcClick = (isCoins) => {
        if (isCoins) {
            this.props.history.push({ pathname: '/transactions', state: { tab: AppLabels.COINS } })
        } else {
            this.goToScreen('/my-wallet')
        }
    }

    renderRightSection = (HeaderOpt) => {
        let btnAction = HeaderOpt.showFilterByTeam ? HeaderOpt.showRosterFilter : this.showFilter;
        let isCoins = (window.location.pathname === '/earn-coins' || window.location.pathname === '/rewards');
        return (
            <React.Fragment>
                <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-between' }}>
                    {
                        (HeaderOpt.skip) &&
                        <a href className="header-action skip-step" onClick={HeaderOpt.skipAction}>
                            {AppLabels.SKIP_STEP}
                        </a>
                    }
                    {
                        (HeaderOpt.filter || HeaderOpt.showFilterByTeam) &&
                        <a href className="header-action" onClick={btnAction}>
                            <i className="icon-filter"></i>
                            {
                                this.state.isFilterselected &&
                                <span className="filter-applied"></span>
                            }
                        </a>
                    }
                    {
                        (HeaderOpt.pitch && this.state.lineupArr.length > 0 && this.hidePitchToolTip()) &&
                        <a href className="header-action hide-sm-above" onClick={HeaderOpt.fieldViewAction}>
                            <i className="icon-ground"></i>
                            {this.state.showTooltip &&
                                <div className="onLoadTooltip">{AppLabels.TAB_TO_SEE_FIELD_VIEW}</div>
                            }
                        </a>
                    }
                    {
                        (HeaderOpt.edit) &&
                        <a href onClick={() => this.goToScreen('/edit-profile')} className="header-action">
                            <i className="icon-edit-line"></i>
                        </a>
                    }
                    {
                        (HeaderOpt.notification) &&
                        <a href className="header-action" onClick={() => this.goToScreen('/notification')}>
                            <i className="icon-alarm-new">
                                {
                                    (this.state.notificationData && this.state.notificationData.count > 0) &&
                                    <div style={{ textAlign: 'center', fontSize: 9, fontFamily: 'Geominist-Bold', position: 'absolute', top: -8, padding: '4px 0px', left: 8, height: 17, width: 17, borderRadius: "100%", backgroundColor: 'red', color: '#fff' }}>
                                        <span>{this.state.notificationData.count > 99 ? '99+' : this.state.notificationData.count}</span>
                                    </div>
                                }
                            </i>
                        </a>
                    }
                    {
                        (HeaderOpt.export) &&
                        <a href className="header-action" >
                            <i className="icon-export-ic">
                            </i>
                        </a>
                    }
                    {
                        (HeaderOpt.statusLeaderBoard) &&
                        <span className="header-action status border-live">
                            {
                                HeaderOpt.statusLeaderBoard == Constants.CONTEST_LIVE &&
                                <span className={"live-indicator " + (HeaderOpt.statusLeaderBoard === Constants.CONTEST_LIVE ? 'live' : '')} />
                            }
                            <span className={"status-text league-margin " + (HeaderOpt.statusLeaderBoard === Constants.CONTEST_LIVE ? 'live' : 'completed')}>{HeaderOpt.statusLeaderBoard === Constants.CONTEST_LIVE ? AppLabels.LIVE : AppLabels.COMPLETED}</span>
                        </span>
                    }

                    {
                        (HeaderOpt.status) &&
                        <span className={"header-action status " + (HeaderOpt.statusBox ? (HeaderOpt.status === Constants.CONTEST_LIVE ? 'status-box-live' : 'status-box-completed') : '')}>
                            {
                                HeaderOpt.status == Constants.CONTEST_LIVE &&
                                <span className={"live-indicator  live-indicator-league" + (HeaderOpt.status === Constants.CONTEST_LIVE ? 'live' : '')} />
                            }
                            <span className={"status-text " + (HeaderOpt.status === Constants.CONTEST_LIVE ? 'live' : 'completed')}>{HeaderOpt.status === Constants.CONTEST_LIVE ? AppLabels.LIVE : AppLabels.COMPLETED}</span>
                        </span>
                    }

                    {
                        (HeaderOpt.close) &&
                        <a href className="header-action" onClick={this.goBackScreen}>
                            <i className="icon-close font-12"></i>
                        </a>
                    }
                    {
                        (HeaderOpt.showBal) &&
                        <div className='right-container-bal-box' onClick={() => this.onHRightBlcClick(isCoins)}>
                            {
                                isCoins ? <div className='balance-box-style is-coin' style={{
                                    display: "flex"
                                }}>{<img className="coin-img" src={Images.IC_COIN} alt="" />} {Utilities.kFormatter(this.state.userCoinBalnc)}</div>
                                    : <div className='balance-box-style'>{Utilities.getMasterData().currency_code} {this.state.mTotalBalance}</div>
                            }
                        </div>
                    }
                    {
                        (HeaderOpt.referAfriend) && WSManager.loggedIn() &&
                        <div className='right-container-refer-f' onClick={() => this.goToScreen('/refer-friend')}>
                            <img className="img-ref" src={Images.REFER_FRIEND_HEADER} alt='' />
                        </div>
                    }
                </div>
            </React.Fragment>
        )
    }

    static showNewPToast = (msg) => {
        globalThis.setState({
            NEWP: true,
            NPMSG: msg ? msg : ''
        })
        setTimeout(() => {
            globalThis.setState({
                NEWP: false
            })
        }, 4000);
    }

    renderNewPrediction = () => {
        const {NPMSG} = this.state;
        return (
            <div onClick={() => Utilities.scrollToTop()} className="new-data-toast">
                <i className="icon-alarm-new primary" />
                <div className="text-msg">{NPMSG ? NPMSG : AppLabels.NEW_PRE}</div>
            </div>
        )
    }

    render() {
        const {
            HeaderOption,
        } = this.props;

        const {
            DailyCheckinBonus,
            CoinCoachMarks,
            RedeemSuccess,
            ReedemCoachMarks,
            showDCBM,
            showCoinCM,
            dailyData,
            showRedeemCM,
            showRSuccess,
            redeemData,
            showResetAlert,
            message,
            isBannerShow,
            SHCoachMarks,
            showSHSCM,
            NEWP
        } = this.state;

        let isCoins = (window.location.pathname === '/earn-coins' || window.location.pathname === '/rewards');
        globalThis = this;

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className={'app-header-style ' + (HeaderOption.hideHeader ? ' hide ' : '') + (HeaderOption.hideShadow ? 'hide-shadow' : '') + (HeaderOption.themeHeader ? ' header-transparent' : '') + (isCoins || HeaderOption.isPrimary ? ' coin-headr ' : '')}>
                        <div style={{ display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between', height:'100%' }}>
                            { NEWP && this.renderNewPrediction() }
                            <div style={{ paddingLeft:10, width:60, justifyContent:'flex-start' }}>
                                { this.renderLeftSection(HeaderOption) }
                            </div>
                            <div style={{ flex:1 }}>
                                { this.renderMiddleSection(HeaderOption) }
                            </div>
                            <div style={{ paddingRight:10, maxWidth:80, minWidth:60 }}>
                                { this.renderRightSection(HeaderOption) }
                            </div>
                        </div>
                        
                        {/*<Row className='row-container'>
                            {
                                NEWP && this.renderNewPrediction()
                            }
                            <Col xs={3} className='section-min section-left'>
                                {
                                    this.renderLeftSection(HeaderOption)
                                }
                            </Col>
                            <Col xs={6} className='section-middle'>
                                {
                                    this.renderMiddleSection(HeaderOption)
                                }
                            </Col>

                            <Col xs={3} className='section-min section-right'>
                                {
                                    this.renderRightSection(HeaderOption)
                                }
                            </Col>
                        </Row>*/}
                        {/* {
                            SHCoachMarks && showSHSCM && !showDCBM && !isBannerShow && <Suspense fallback={<div />} ><SHCoachMarks {...this.props} cmData={{
                                mShow: window.location.pathname !== '/what-is-new' && showSHSCM,
                                mHide: this.hideSHSCM
                            }} /></Suspense>
                        } */}
                        {
                            Utilities.getMasterData().a_coin !== "0" &&
                            <React.Fragment>
                                {
                                    !HeaderOption.isOnb && DailyCheckinBonus && !showCoinCM && showDCBM && <Suspense fallback={<div />} ><DailyCheckinBonus {...this.props} preData={{
                                        dailyData: dailyData,
                                        mShow: showDCBM,
                                        mHide: this.hideDailyCheckIn
                                    }} /></Suspense>
                                }
                                {/* {
                                    CoinCoachMarks && showCoinCM && <Suspense fallback={<div />} ><CoinCoachMarks {...this.props} cmData={{
                                        mShow: showCoinCM,
                                        mHide: this.hideCoinCM
                                    }} /></Suspense>
                                } */}
                                {
                                    ReedemCoachMarks && !showDCBM && showRedeemCM && <Suspense fallback={<div />} ><ReedemCoachMarks {...this.props} cmData={{
                                        mHide: this.hideRedeemCM,
                                        mShow: showRedeemCM
                                    }} /></Suspense>
                                }
                                {
                                    RedeemSuccess && showRSuccess && <Suspense fallback={<div />} ><RedeemSuccess {...this.props} rmData={{
                                        redeemData: redeemData,
                                        mShow: showRSuccess,
                                        mHide: this.hideRSuccess
                                    }} /></Suspense>
                                }

                                {
                                    this.state.showRCM && window.location.pathname === '/lobby' && !this.state.showDCBM && !this.state.showCoinCM && !this.state.isBannerShow && !this.state.showSHSCM && <Suspense fallback={<div />} ><RefferCoachMark {...this.props} cmData={{
                                        mShow: this.state.showRCM,
                                        mHide: this.hideRCM,
                                        refRCMData: this.state.refRCMData,
                                    }} /></Suspense>
                                }
                            </React.Fragment>
                        }
                        {
                            (!showDCBM && !HeaderOption.isOnb && isBannerShow) &&
                            <Suspense fallback={<div />} ><Banner
                                isBannerShow={true}
                                onBannerHide={() => this.onBannerHide()}
                            /></Suspense>
                        }
                        {
                            showResetAlert &&
                            <Suspense fallback={<div />} ><MyAlert isMyAlertShow={showResetAlert} onMyAlertHide={() => this.GobackToLobby()} hidemodal={() => this.resetConfirmHide()} message={message} /></Suspense>
                        }
                    </div>
                )}

            </MyContext.Consumer>
        )
    }
}